/* eslint-disable */

import { mapState, mapMutations, mapGetters } from 'vuex'
import { api } from "../request/req.js"
import Head from './Head.vue';
import Foot from './Foot.vue';
import { xm } from '../utils/utils.js'
import { isMobile } from 'vant/lib/utils/basic.js';


export default {
  name: 'Pay',
  components: {
    Head, Foot
  },
  computed: {
    ...mapState(['userInfo', 'gameInfo', 'games', 'roleInfo']),
    hasLogin() {
      return this.isLogined()
    },
    hasLoginRole() {
      return this.isLogined()
    },
    gameName() {
      return this._getGame() && this._getGame().name || '請選擇'
    },
    serverName() {
      return this._getServer() && this._getServer().name || '請選擇伺服器'
    },
    roleName() {
      return this._getRole() && this._getRole().name || '請選擇角色'
    },
    ageDesc() {
      return this._getAge() && this._getAge().name || ''
    },
    payProductName() {
      var p = this._getCurrentProduct()
      if (!p) return ''

      return p.amount + (p.rebateCount > 0 ? '+' + p.rebateCount + '(贈)' : '')
    },
    
    payProductName1() {
      var p = this._getCurrentProduct()
      if (!p) return ''

      return p.amount || ''
    },
    
    payProductName2() {
      var p = this._getCurrentProduct()
      if (!p) return ''

      return p.rebateCount || ''
    },

    product() {
      return this._getCurrentProduct() || {}
    },
    productAmount() {
      var p = this._getCurrentProduct() || {}
      if (!p.amount || p.amount <= 0) {
        return '-'
      }
      return (p.amount + p.rebateCount) + ''
    },
    gameImg() {
      return id => {
        return require('../assets/recharge/' + id + '.png')
      }
    },
    payPaymentIcon() {
      var p = this.gameInfo.payments[this.selObj.paymentIndex].key || ''
      return require(`../assets/images/pay/payment/${p}.png`)
    },
    payPaymentProductIcon() {
      var p = this.gameInfo.payments[this.selObj.paymentIndex].key || ''
      return require(`../assets/images/pay/payment/tip/${p}.png`)
    },
    // payPaymentN() {
    //   var p = this.gameInfo.payments[this.selObj.paymentIndex].key || ''
    //   return require(`../assets/pay/${p}-n.png`)
    // },
    payPaymentName() {
      return this.gameInfo.payments[this.selObj.paymentIndex].name || ''
    },
    totelInfo() {
      if (this.goodsType === 0) {
        if (this.goodsGlodIndex == undefined) {
          return { amount: 0, currency: "TWD", name: "" };
        } else {
          let list = this.goodsGold || [{ amount: 0, currency: "TWD", name: "" }];
          let index = this.goodsGlodIndex || 0;
          return list[index];
        }
      } else {
        if (this.goodGiftIndex == undefined) {
          return { amount: 0, currency: "TWD", name: "" };
        } else {
          let list = this.goodGift || [
            { amount: 0, currency: "TWD", name: "" },
          ];
          let index = this.goodGiftIndex || 0;
          return list[index];
        }
      }
    }
  },
  watch: {

  },
  data() {
    return {

      loginAgreePrivacy: true,
      showLogin: 0,
      isLogining: false,
      loginAccount: '',
      loginPassword: '',

      showLogout: 0,
      showLogoutAlert: 0,

      showPayemnt: 0,
      showProduct: 0,
      productList: [
        // { id: 10001, name: 'r1', product_id: 'com.test1', amount: 1, gold: 1, show: 1 },
        // { id: 10002, name: 'r2', product_id: 'com.test2', amount: 2, gold: 2, show: 1 }
      ],

      showAge: 0,
      ageList: [{ id: 1, age: 18, name: "18嵗及以上" }, { id: 1, age: 16, name: "16-17嵗" }, { id: 1, age: 15, name: "15嵗及以下" }],


      showServers: false,
      serverList: [],//[{ id: 10001, name: 's1' }, { id: 10002, name: 's2' }, { id: 10001, name: 's3' }, { id: 10002, name: 's4' }],
      showRoles: false,
      roleList: [],//[{ id: 10001, name: 'r1' }, { id: 10002, name: 'r2' }, { id: 10001, name: 'r3' }, { id: 10002, name: 'r4' }, { id: 10001, name: 'r5' }, { id: 10002, name: 'r22' }],
      tabList: ['儲值'],//, 'NẠP TÍCH LŨY', 'SỰ kIỆN'],
      currentTabIndex: 0,

      selObj: {
        gameIndex: -1,
        serverIndex: -1,
        roleIndex: -1,
        productIndex: -1,
        paymentIndex: 0,
        ageIndex: 0,
      },
      loading: false,

      thirdLogin: {
        google: false,
        apple: false,
        fb: false
      },

      isSDK: 0,
    }
  },
  filters: {
    formater(value) {
      const replacedStr = value && value.replace(/\\n/g, "\n") || ''
      const newStr = replacedStr.replace(/ /g, '')
      return newStr;
    }
  },
  created() {
    let token = this.$route.query.token || ''
    let appId = this.$route.query.app_id || ''
    if (token && token.length > 0) {
      this.showLoading()

      //兼容appid没传的问题
      let app = Number(appId)
      if (app != 0) {
        this.tokenTryLogin(token, app, d => {
          this.hideLoading()
          this.tokenLoginSuccess(d, token)
        }, e => {
          this.hideLoading()
          this.tip(e.msg || '')
        })
        return
      }
      this.hideLoading()
      return
    }
  },
  mounted() {
    for (let game of this.games) {
      if (game.id == this.gameInfo.id && game.appId == this.gameInfo.appId) {
        this.changeGame(this.games.indexOf(game))
      }
    }
    this.initThird()
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    ...mapMutations(['loginLocal', 'setGameInfo', 'logout', 'loginRole']),

    getPaymentImg(payMethod) {
      return require(`../assets/images/pay/payment/${payMethod}.png`)
    },
    downloadApk() {
      window.open('https://download.godsarrive.com/1.0.0.apk', "_blank")
    },
    toCustomer() {
      this.showLogoutAlert = false
      window.open('https://www.facebook.com/godsarrive1', "_blank")
    },
    toTerms() {
      this.showLogoutAlert = false
      window.open('https://www.godsarrive.com/terms.html', "_blank")
    },
    toPrivacy() {
      this.showLogoutAlert = false
      window.open('https://www.godsarrive.com/privacy.html', "_blank")
    },
    tokenTryLogin(token, appId, success, fail) {
      api.tokenLogin({
        token: token,
        app_id: appId
      }).then(d => {
        if (success) success(d)
      }).catch(e => {
        if (fail) fail(e)
        // this.$router.replace('/account')  
      })
    },
    tokenLoginSuccess(d, token) {
      d.token = token
      this.loginLocal(d)
      this.resetGameInfo()
    },
    resetGameInfo() {
      this.changeServer(-1)
      this.changeRole(-1)
      this.roleList = []
      this.isLogining = false
      this.showLogin = false;
    },
    login() {
      if (!this.loginAccount) {
        this.tip('請輸入您的帳戶');
        return;
      }
      if (!this.loginPassword) {
        this.tip('請輸入您的密碼');
        return;
      }
      if (!this.loginAgreePrivacy) {
        this.tip("請同意協定")
        return;
      }
      if (this.isLogining) return
      this.isLogining = true

      let param = {
        app_id: this.getAppId(),
        account: this.loginAccount,
        password: this.loginPassword,
        device_id: ''
      }
      api.login(param).then(d => {
        this.tip('登錄成功')
        this.loginLocal(d)
        this.resetGameInfo()
        this.loginAccount = ''
        this.loginPassword = ''
      }).catch(e => {
        console.error(e)
        this.isLogining = false
        let msg = e.msg;
        // 如果msg是数组且内容为'6'，替换为中文提示
        if (Array.isArray(msg) && msg.length === 1 && msg[0] === '6') {
          msg = '密碼必須至少有6個字元';
          alert(msg);
          return;
        }
        // 通过code判断账号或密码错误
        if (e.code === 1016) {
          alert('帳戶/密碼不正確');
          return;
        }
        this.tip(msg || e || 'unknow err')
      })

    },

    fbLogin() {
      FB && FB.getLoginStatus(response => {
        if (!response.session) {
          this.fb2login()
          return
        }

        FB.logout(r => {
          this.fb2login()
        })
      })
    },
    fb2login() {
      FB.login(r => {
        console.error('fb登录结果：', r)
        if (r.status === 'connected') {
          console.error('登录成功')
          api.facebookLogin({
            app_id: this.getAppId(),
            id_token: r.authResponse && r.authResponse.accessToken || ''
          }).then(d => {
            this.loginLocal(d)
            this.resetGameInfo()
          }).catch(e => {
            console.error(e)
            this.tip(e)
          })
        } else {
          this.tip('fail')
        }
      })
    },
    appleLogin(config) {
      if (!AppleID) return
      AppleID.auth.init(Object.assign({
        scope: "name email", // To tell apple we want the user name and emails fields in the response it sends us.
        state: "origin:web", // Any string of your choice that you may use for some logic. It's optional and you may omit it.
        usePopup: false, // Important if we want to capture the data apple sends on the client side.
      }, config));
    },
    googleLogin() {
      // let fallbackTimer = setTimeout(() => {
      //   // 兜底：3 秒没反应就展示官方按钮
      //   this.thirdLogin.google = false
      //   document.getElementById("gg").style.display = "block";
      // }, 8000);

      // google.accounts.id.prompt((n) => {
      //   if (n.isNotDisplayed() || n.isSkippedMoment()) {
      //     clearTimeout(fallbackTimer);
      //     this.thirdLogin.google = false
      //     document.getElementById("gg").style.display = "block";
      //   }
      // });
    },
    handleCredentialResponse(r) {
      console.log("123",r)
      api.googleLogin({
        app_id: this.getAppId(),
        id_token: r.credential
      }).then(d => {
        this.loginLocal(d)
        this.resetGameInfo()
        this.thirdLogin.google = true
        document.getElementById("gg").style.display = "none";
      }).catch(e => {
        console.error(e)
        this.tip(e)
      })
    },
    initThird() {
      const google = document.createElement('script');
      google.type = 'text/javascript';
      google.src = 'https://accounts.google.com/gsi/client';
      google.onload = () => {
        this.thirdLogin.google = true
        this.createdGoogleLogin(this.getGoogleConfigId())
      }
      // google.async = true
      document.body.appendChild(google);


      const fb = document.createElement('script');
      fb.type = 'text/javascript';
      fb.src = 'https://connect.facebook.net/en_US/sdk.js';
      fb.async = true
      fb.defer = true
      fb.crossOrigin = 'anonymous'
      fb.onload = () => {
        FB.init({
          appId: this.getFbConfigId(),
          autoLogAppEvents: true,
          xfbml: true,
          version: 'v20.0'
        });
        this.thirdLogin.fb = true
      }
      document.body.appendChild(fb);

      const ap = document.createElement('script');
      ap.type = 'text/javascript';
      ap.src = 'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js';
      ap.onload = () => {
        this.appleLogin(this.getAppleConfig());
        this.thirdLogin.apple = true
      }
      document.body.appendChild(ap);
    },
    getAppId() {
      return this._getGame().appId
    },
    getAppleConfig() {
      return this.gameInfo.apple
    },
    getFbConfigId() {
      return this.gameInfo.facebook.appId
    },
    getGoogleConfigId() {
      return this.gameInfo.google.clientId
    },
    createdGoogleLogin(googleClientId) {
      if (!google) return
      google.accounts.id.initialize({
        client_id: googleClientId,
        callback: this.handleCredentialResponse
      });

      const rem = parseFloat(
        getComputedStyle(document.documentElement).fontSize
      );

      const heightPx = Math.round(8.8 * rem); // 3rem → px

      google.accounts.id.renderButton(
        document.getElementById("gg"),
        { 
          type: "standard", //icon。standard
          theme: "outline", //filled_blue。 filled_black outline
          size: "large",
    // shape: "circle",
          // width: 400
        }  // customization attributes
      );
      // document.getElementById("gg").style.display = "none";
    },

    showLoginDialog() {
      this.showLogin = true
    },
    hideLoginDialog() {
      this.showLogin = false
    },
    showLogoutDialog() {
      this.showLogoutAlert = false
      this.showLogout = true
    },
    hideLogoutDialog() {
      this.showLogout = false
    },
    logout2() {
      this.hideLogoutDialog()
      this.logout()
    },

    showNormalTip(s) {
      alert(s)
      
    },
    queryOrder() {
      this.payAlertInfo.show = false
      this.showLoading()
      api.orderStatus({
        order_sn: this.payAlertInfo.orderSn
      }).then(d => {
        this.hideLoading()
        if (d.ok) {
          this.showPaySuccess(this.payAlertInfo.orderSn)
        } else {
          this.showNormalTip('正在處理訂單')//訂單正在被處理中
        }
      }).catch(e => {
        this.hideLoading()
        this.tip(e)
      })
      // alert('queryOrder:' + this.payAlertInfo.orderSn)
    },
    isEmpty(s) {
      return !s || s.length == 0
    },
    toPay() {
      if (!this._getGame()) {
        this.tip('選擇遊戲')//請選擇遊戲
        return
      }
      if (!this._getServer()) {
        this.tip('請選擇服務器')//請選擇服務器
        return
      }
      if (!this._getRole()) {
        this.tip('選擇角色')//請選擇角色
        return
      }
      if (!this._getCurrentProduct()) {
        this.tip('請選擇儲值項')//請選擇儲值項
        return
      }
      this.callPay()
    },
    tip(e) {
      console.error(e)
      if (e.data && e.data.order_sn) {
        this.showPayFail(e.data.order_sn || 'data error', e.msg || 'msg error')
        return
      }
      this.showNormalTip(e.msg || e || 'error')
    },
    pay10046() {
      var p = {
        app_id: this.gameInfo.appId,
        gid: this.gameInfo.id,
        server_id: this._getServer().id + '',
        role_id: this._getRole().id + '',
        role_name: this._getRole().name,
        product_id: this._getCurrentProduct().product_id || ''
      }

      this.showLoading()
      api.travelletPay(p).then(d => {
        this.hideLoading()
        if (d.url) {
          if (this.isSDK) {
            window.location.href = d.url
          } else {
            window.location.href = d.url
            this.payAlertInfo.show = true
            // this.showUrlTip(d.url, d.order_sn)
          }
        }
      }).catch(e => {
        this.hideLoading()
        this.tip(e)
      })
    },
    pay10051() {
      var p = {
        app_id: this.gameInfo.appId,
        product_id: this._getCurrentProduct().product_id || '',
        gid: this.gameInfo.id,
        server_id: this._getServer().id + '',
        role_id: this._getRole().id + '',
        role_name: this._getRole().name,
        pay_method: this.gameInfo.payments[this.selObj.paymentIndex].payMethod || ''
      }

      this.showLoading()
      api.pay(p).then(d => {
        this.hideLoading()
        if (d.url) {
          if (this.isSDK) {
            window.location.href = d.url
          } else {
            if (this.isMobileDevice()) {
              window.location.href = d.url
              setTimeout(() => { this.showPayQuery() }, 2000)
            }
            else {
              this.showUrlTip(d.url, d.order_sn)
            }



          }
        }
      }).catch(e => {
        this.hideLoading()
        this.tip(e)
      })
    },
    isMobileDevice() {
      // Regular expressions to match mobile devices
      const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;

      // Get the user agent string from the navigator object
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;

      // Check if the user agent matches any of the mobile regex patterns
      return mobileRegex.test(userAgent);
    },
    showLoading() {
      this.loading = true
    },
    hideLoading() {
      this.loading = false
    },
    _getCurrentProduct() {
      if (this.selObj.productIndex < 0) return false
      return this.productList[this.selObj.productIndex]
    },

    checkLogin(cb) {
      if (!this.isLogined()) {
        return
      }
      cb()
    },
    isLogined() {
      return this.userInfo.token.length > 0
    },
    changeGame(index) {
      if (this.selObj.gameIndex == index) return
      this.selObj.gameIndex = index

      this.setGameInfo(this._getGame())

      this.changeServer(-1)
      this.serverList = []
      this.changeRole(-1)
      this.roleList = []

      this.selObj.productIndex = -1
      this.getServers()
      this.getProducts()
    },
    _getGame() {
      if (this.selObj.gameIndex == -1) {
        return null
      }
      return this.games[this.selObj.gameIndex]
    },

    _getServer() {
      if (this.selObj.serverIndex == -1) {
        return null
      }
      return this.serverList[this.selObj.serverIndex]
    },
    getServers() {
      console.log('getServers')
      api.serverList({
        app_id: this.gameInfo.appId,
        gid: this.gameInfo.id,
      }).then(d => {
        this.serverList = d || []
        if (this.serverList.length > 0) {
          if (this.roleInfo.sid != '0') {
            for (let index = 0; index < this.serverList.length; index++) {
              const element = this.serverList[index];
              if (element.id == this.roleInfo.sid) {
                this.changeServer(index)
                break
              }
            }
          }else{
            this.changeServer(0)
          }
        }
      }).catch(e => {
        this.tip(e)
        console.error(e)
        this.serverList = []
      })
    },
    _getRole() {
      if (this.selObj.roleIndex == -1) {
        return null
      }
      return this.roleList[this.selObj.roleIndex]
    },
    getRoles() {
      if (!this.isLogined()) return
      let server = this._getServer();
      console.error('-==--')
      server && api.roleList({
        app_id: this.gameInfo.appId,
        gid: this.gameInfo.id,
        server_id: server.id,
      }).then(d => {
        this.roleList = d || []
        if (this.roleList.length > 0) {
          if (this.roleInfo.rid != '0') {
            for (let index = 0; index < this.roleList.length; index++) {
              const element = this.roleList[index];
              if (element.id == this.roleInfo.rid) {
                this.changeRole(index)
                break
              }
            }
          }else{
            this.changeRole(0)
          }
        }
      }).catch(e => {
        this.tip(e)
        console.error(e)
        this.roleList = []
      })
    },
    getProducts() {
      api.productsList({
        app_id: this.gameInfo.appId,
        gid: this.gameInfo.id,
      }).then(d => {
        var r = d.list || {}
        var list = r['1'] || []
        var results = []
        for (var i of list) {
          i.sel = false
          i.first = i.refer.first
          i.hot = i.refer.hot
          i.rebate = i.refer.rebate || 0
          i.rebateCount = i.refer.rebateCount || 0
          results.push(i)
        }
        this.productList = results.sort((a, b) => a.amount - b.amount) || []
      }).catch(e => {
        this.tip(e)
      })
    },
    showAgeDialog() {
      this.showAge = true
    },
    selAge(index) {
      this.showAge = false
      if (this.selObj.ageIndex == index) return
      this.selObj.ageIndex = index
    },
    _getAge() {
      if (this.selObj.ageIndex == -1) {
        return null
      }
      return this.ageList[this.selObj.ageIndex]
    },
    showPaymentDialog() {
      this.showPayemnt = true
    },
    hidePaymentDialog() {
      this.showPayemnt = false
    },
    selPayment(index) {
      this.showPayemnt = false
      if (this.selObj.paymentIndex == index) return
      this.selObj.paymentIndex = index
    },
    // 错误消息提醒
    showError(message) {
      this.tip(message)
    },
 
    pay(index) {
      if (!this.isLogined()) {
        this.showLoginDialog()
        return
      }
      if (!this._getServer()) {
        this.tip('請選擇服務器')//請選擇服務器
        return
      }
      if (!this._getRole()) {
       this.tip('請選擇角色')//請選擇角色
        return
      }
      this.selProduct(index)
      if (!this._getCurrentProduct()) {
        this.tip('請選擇儲值項')//請選擇儲值項
        return
      }

      this.showProductDialog()
    },
    callPay() {
      var payMethod = this.getCurrentPaymethod()
      console.error('-------')
      var p = {
        app_id: this.gameInfo.appId,
        age: this._getAge().age || 18,
        product_id: this._getCurrentProduct().product_id,
        server_id: this._getServer().id + '',
        role_id: this._getRole().id + '',
        role_name: this._getRole().name,
        pay_method: payMethod
      }

      this.showLoading()
      api.pay(p).then(d => {
        this.hideLoading()
        this.handlerPayResult(d)
      }).catch(e => {
        this.hideLoading()
        this.tip(e)
      })
    },
    handlerPayResult(d) {
      // this.closeConfirmDialog()
      window.location.href = d.url
      // if (this.isAirwallex()) {
      //   var data = {
      //     methods: [this.getCurrentPaymethod().replace('airwallex--', '')]
      //   }
      //   console.error(222)
      //   if (this.getCurrentPaymethod().indexOf('applepay') >= 0) {
      //     data.applePayRequestOptions = {
      //       countryCode: 'HK'
      //     }
      //   }
      //   this.toPayAirWallex(d, data)
      //   return
      // }
      // if (this.isAdyen()) {
      //   this.toAdyen(d)
      //   return
      // }
      // if (this.isXsolla()) {
      //   this.toXsolla(d)
      //   return
      // }
      // if (this.isGash()) {
      //   this.toGash(d)
      //   return
      // }
    },
    getCurrentPaymethod() {
      return this.gameInfo.payments[this.selObj.paymentIndex].payMethod || ''
    },
    selProduct(index) {
      if (this.selObj.productIndex == index) return
      this.selObj.productIndex = index
    },
    showProductDialog() {
      this.showProduct = true
    },
    hideProductDialog() {
      this.showProduct = false
    },
    changeTab(index) {
      this.currentTabIndex = index
    },
    toggleRoleView() {
      this.showRoles = !this.showRoles
      this.showServers = false
    },
    changeRole(index) {
      this.showRoles = false
      if (this.selObj.roleIndex == index) return
      this.selObj.roleIndex = index

       this.loginRole({
        rid: (this._getRole() && this._getRole().id || 0) + ''
      })
    },
    toggleServerView() {
      this.showServers = !this.showServers
      this.showRoles = false
    },
    changeServer(index) {
      this.showServers = false
      if (this.selObj.serverIndex == index) return
      this.selObj.serverIndex = index

      this.selObj.roleIndex = -1
      console.log('22')
      this.getRoles()

      this.loginRole({
        sid: (this._getServer() && this._getServer().id || 0) + ''
      })
    },
  }
}